import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IKpiConfScore, defaultValue } from 'app/shared/model/kpi-conf-score.model';

const initialState: EntityState<IKpiConfScore> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/kpi-conf-scores';

// Actions

export const getEntitiesList = createAsyncThunk('kpiConfScore/fetch_entity_list_all', async (companyId?: number | null) => {
  let requestUrl = `${apiUrl}-list`;

  if (companyId !== null && companyId !== undefined) {
    requestUrl += `?companyId=${companyId}`;
  }

  return axios.get<IKpiConfScore[]>(requestUrl);
});

export const restoreDefault = createAsyncThunk('kpiConfScore/restore_default', async (companyId?: number | null) => {
  let requestUrl = `${apiUrl}-restore-default`;

  if (companyId !== null && companyId !== undefined) {
    requestUrl += `?companyId=${companyId}`;
  }

  return axios.post<IKpiConfScore[]>(requestUrl);
});

export const updateEntitiesBatch = createAsyncThunk(
  'kpiConfStore/update_entities_batch',
  async (entities: IKpiConfScore[]) => {
    const requestUrl = `${apiUrl}/batch`;
    const cleanedEntities = entities.map(cleanEntity);
    const result = await axios.put<IKpiConfScore[]>(requestUrl, cleanedEntities);
    return result;
  },
  { serializeError: serializeAxiosError }
);

// slice

export const KpiConfScoreSlice = createEntitySlice({
  name: 'kpiConfScore',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEntitiesList), (state, action) => {
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
          totalItems: parseInt(action.payload.headers['x-total-count'], 10),
        };
      })
      .addMatcher(isFulfilled(updateEntitiesBatch, restoreDefault), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
        state.entities = action.payload.data;
      })
      .addMatcher(isPending(getEntitiesList), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addMatcher(isPending(updateEntitiesBatch, restoreDefault), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      });
  },
});

export const { reset } = KpiConfScoreSlice.actions;

export default KpiConfScoreSlice.reducer;
